import { NgModule } from "@angular/core";
import { AdminComponent } from "./admin.component";
import { RouterModule } from "@angular/router";
import { AsyncPipe, CommonModule, DatePipe, NgOptimizedImage } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CreateOrEditComponent } from "./createredit/createoredit.component";
import { MatCalendar, MatDatepicker } from "@angular/material/datepicker";
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatIconModule } from "@angular/material/icon";
import { MatFormFieldModule, MatLabel, MatError, MatHint } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule, MatSelect, MatOption } from '@angular/material/select';
import { Select2 } from 'ng-select2-component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { DeleteModalComponent } from "./deleteModal.component";
import { MatButtonModule } from "@angular/material/button";
import { NgbCollapse, NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CreateOrUpdateExceptionComponent } from "./createorupdateexception/create-or-update-exception.component";
import { CalendarSectionComponent } from "./calendarsection/calendar-section.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NavbarComponent } from "./navbar/navbar.component";
import { MatListModule } from "@angular/material/list";
import { MatDividerModule } from "@angular/material/divider";

@NgModule({
    declarations: [
        AdminComponent,
        CreateOrEditComponent,
        CreateOrUpdateExceptionComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        DatePipe,
        AsyncPipe,
        FormsModule,
        ReactiveFormsModule,
        MatCalendar,
        MatCardModule,
        MatDatepicker,
        MatFormFieldModule,
        MatLabel,
        MatError,
        MatHint,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatSelect,
        MatOption,
        MatButtonModule,
        Select2,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatButtonModule,
        DeleteModalComponent,
        NgbDropdownModule,
        MatTableModule,
        MatCheckboxModule,
        CalendarSectionComponent,
        NgOptimizedImage,
        NgbCollapse,
        MatTooltipModule,
        NavbarComponent,
        MatListModule,
        MatDividerModule
    ],
    exports: [
        AdminComponent,
        CreateOrEditComponent,
        CreateOrUpdateExceptionComponent
    ]
})
export class AdminModule {}

